import React from "react";
import LessonStatusResult from "../LessonStatusResult/LessonStatusResult";
import { GroupsDropdown } from "../GroupsDropdown/GroupsDropdown";
import { StatusDropdown } from "../StatusDropdown/StatusDropdown";
import { DatePick } from "../../DatePicker/DatePicker";
import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import LessonTeachersDropdown from "../LessonTeachersDropdown/LessonTeachersDropdown";
import { ReactComponent as HalfCircleICon } from "../../../assets/icons/filter/half-circle-svgrepo-com.svg";
import { LessonTypesDropdown } from "../LessonTypesDropdown/LessonTypesDropdown";
import { TeachersDropdown } from "../TeachersDropdown/TeachersDropdown";
import { useSelector } from "react-redux";

const WorkersTableHead = ({ showAddBtn, filter, openModal, count }) => {
  const { selectedGroup } = useSelector((state) => state.dropdownGroup);
  return (
    <div className="lesson-page-header-container">
      <div className="lesson-page-header-top">
        {showAddBtn && (
          <div className="lesson-page-add-btn">
            <button className="add-detail" onClick={openModal}>
              <PlusIcon />
              Əlavə et
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkersTableHead;
